"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUpsellSettings = exports.selectUiSettings = exports.selectTransformedSettings = exports.selectTenantsWithHiddenOrderSummary = exports.selectSettings = exports.selectSectionSizes = exports.selectReplacedRecommendedProductWithAlternative = exports.selectProductCatalog = exports.selectIsWidgetReady = exports.selectIsWidgetLoaded = exports.selectInstanceId = exports.selectDevSettings = exports.selectDefaultMetadata = exports.selectConfigTenant = exports.selectConfigShareRecommendation = exports.selectConfigQuestions = exports.selectConfigMarket = exports.selectConfig = exports.selectComparisonSettings = exports.selectCategoryPriceTypes = exports.selectCTASettings = void 0;
const selectIsWidgetLoaded = instanceId => state => {
  return state.drools[instanceId].widget.isWidgetLoaded;
};
exports.selectIsWidgetLoaded = selectIsWidgetLoaded;
const selectIsWidgetReady = instanceId => state => {
  return state.drools[instanceId].widget.isWidgetReady;
};
exports.selectIsWidgetReady = selectIsWidgetReady;
const selectInstanceId = instanceId => state => {
  return state.drools[instanceId].widget.instanceId;
};
exports.selectInstanceId = selectInstanceId;
const selectConfig = instanceId => state => {
  var _state$config, _state$config$data;
  const modifiedInstanceId = instanceId.replace(/_/g, '-');
  return (_state$config = state.config) === null || _state$config === void 0 ? void 0 : (_state$config$data = _state$config.data) === null || _state$config$data === void 0 ? void 0 : _state$config$data.widgets.drools[modifiedInstanceId];
};
exports.selectConfig = selectConfig;
const selectConfigQuestions = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.questions;
};
exports.selectConfigQuestions = selectConfigQuestions;
const selectDefaultMetadata = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return (config === null || config === void 0 ? void 0 : config.defaultMetadata) || {};
};
exports.selectDefaultMetadata = selectDefaultMetadata;
const selectCategoryPriceTypes = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return (config === null || config === void 0 ? void 0 : config.categoryPriceTypes) || [];
};
exports.selectCategoryPriceTypes = selectCategoryPriceTypes;
const selectSettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return (config === null || config === void 0 ? void 0 : config.settings) || {};
};
exports.selectSettings = selectSettings;
const selectDevSettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.devSettings;
};
exports.selectDevSettings = selectDevSettings;
const selectUpsellSettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.upsellSettings;
};
exports.selectUpsellSettings = selectUpsellSettings;
const selectTransformedSettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  const transformedSettings = {};
  Object.keys(config === null || config === void 0 ? void 0 : config.settings).forEach(key => {
    if (key !== 'searchSettings') {
      transformedSettings[key] = config === null || config === void 0 ? void 0 : config.settings[key];
    } else {
      config === null || config === void 0 ? void 0 : config.settings[key].forEach(searchSetting => {
        transformedSettings[`model.${searchSetting.name}`] = searchSetting.value;
      });
    }
  });
  return transformedSettings;
};
exports.selectTransformedSettings = selectTransformedSettings;
const selectCTASettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.CTASettings;
};
exports.selectCTASettings = selectCTASettings;
const selectProductCatalog = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.productCatalog;
};
exports.selectProductCatalog = selectProductCatalog;
const selectComparisonSettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.comparisonSettings;
};
exports.selectComparisonSettings = selectComparisonSettings;
const selectSectionSizes = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.sectionSizes;
};
exports.selectSectionSizes = selectSectionSizes;
const selectConfigTenant = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.tenant;
};
exports.selectConfigTenant = selectConfigTenant;
const selectTenantsWithHiddenOrderSummary = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return (config === null || config === void 0 ? void 0 : config.tenantsWithHiddenOrderSummary) || [];
};
exports.selectTenantsWithHiddenOrderSummary = selectTenantsWithHiddenOrderSummary;
const selectConfigMarket = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.market;
};
exports.selectConfigMarket = selectConfigMarket;
const selectConfigShareRecommendation = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.showShareRecommendation;
};
exports.selectConfigShareRecommendation = selectConfigShareRecommendation;
const selectReplacedRecommendedProductWithAlternative = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return config === null || config === void 0 ? void 0 : config.replacedRecommendedProductWithAlternative;
};
exports.selectReplacedRecommendedProductWithAlternative = selectReplacedRecommendedProductWithAlternative;
const selectUiSettings = instanceId => state => {
  const config = selectConfig(instanceId)(state);
  return (config === null || config === void 0 ? void 0 : config.uiSettings) || {
    showModalView: true,
    showDefaultUi: true,
    showBanner: false
  };
};
exports.selectUiSettings = selectUiSettings;